import { forwardRef } from "react";

import type { Icon } from "./index";

export const CuraiLogo: Icon = forwardRef((props, ref) => (
  <svg
    ref={ref}
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="curaiLogoTitle"
  >
    <title id="curaiLogoTitle">Curai Logo</title>
    <path
      d="M8.59643 17.5964C6.31652 17.5964 4.12998 16.6907 2.51784 15.0786C0.905694 13.4664 0 11.2799 0 9C0 6.72008 0.905694 4.53355 2.51784 2.9214C4.12998 1.30926 6.31652 0.403564 8.59643 0.403564V17.5964Z"
      fill="currentColor"
    />
    <path
      d="M14.1028 8.19227C16.2531 8.19227 17.9963 6.44911 17.9963 4.2988C17.9963 2.1485 16.2531 0.405334 14.1028 0.405334C11.9525 0.405334 10.2094 2.1485 10.2094 4.2988C10.2094 6.44911 11.9525 8.19227 14.1028 8.19227Z"
      fill="currentColor"
    />
    <path
      d="M14.1042 17.5963C14.8746 17.5965 15.6277 17.3683 16.2684 16.9404C16.909 16.5126 17.4084 15.9043 17.7033 15.1926C17.9982 14.4809 18.0755 13.6977 17.9252 12.9421C17.775 12.1865 17.404 11.4925 16.8593 10.9477C16.3145 10.403 15.6205 10.032 14.8649 9.88175C14.1093 9.73152 13.3261 9.80875 12.6144 10.1037C11.9027 10.3986 11.2944 10.898 10.8666 11.5386C10.4387 12.1793 10.2105 12.9324 10.2107 13.7028V17.5963H14.1042Z"
      fill="currentColor"
    />
  </svg>
));
CuraiLogo.displayName = "CuraiLogo";
